import { ThemeOptions } from '@mui/material';

export const menuItemThemeOptions: ThemeOptions = {
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: '2px',
        },
      },
    },
  },
};
